import { SECTION_TYPES } from "@/constants/InspectionReportGenerator.js";
import { InventoryLinksParams, InspectionLinksParams } from "@/constants/PowerBIParams";

/**
 * Generates Power BI parameters based on the provided section type and other details.
 *
 * @param {Object} options - The options object.
 * @param {string} options.sectionTypeId - The section type identifier.
 * @param {string} options.brKey - The bridge key.
 * @param {string} options.inspectionDate - The inspection date.
 * @param {string} options.user - The user id.
 * @returns {Array<Object>} The array of Power BI parameters.
 */
export const getPowerBIParams = ({
  sectionTypeId,
  brKey,
  inspectionDate,
  user,
  selectedPowerBIReportParams,
  inspectionId,
}) => {
  const params = [
    {
      name: "User",
      value: user,
    },
  ];

  switch (sectionTypeId) {
    case SECTION_TYPES.D491: {
      getD491Params(params, brKey, inspectionId, selectedPowerBIReportParams);
      break;
    }
    case SECTION_TYPES.SCOUR_POA: {
      params.push(
        {
          name: "BRKEY",
          value: brKey,
        },
        {
          name: "InspDate",
          value: inspectionDate,
        }
      );
      break;
    }
  }
  return params;
};

const getD491Params = (params, brKey, inspectionId, selectedPowerBIReportParams = []) => {
  params.push(
    {
      name: "BridgeKey",
      value: brKey,
    },
    {
      name: "InspectionId",
      value: inspectionId,
    }
  );

  if (selectedPowerBIReportParams.length === 0) {
    return;
  }

  for (const index in selectedPowerBIReportParams) {
    const param = selectedPowerBIReportParams[index];
    let item = InventoryLinksParams.params.find((item) => item.value === param);
    if (item) {
      params.push({
        name: InventoryLinksParams.name,
        value: param,
      });
      continue;
    }
    item = InspectionLinksParams.params.find((item) => item.value === param);
    params.push({
      name: InspectionLinksParams.name,
      value: param,
    });
  }
};
